import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Drawer } from "@mui/material";
import { useLocation } from "react-router-dom";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useSidebar } from "../../contexts/SidebarContext";
import { useTheme, useMediaQuery } from "@mui/material";
const SidebarContent = ({ onNavigate }) => {
    const location = useLocation();
    const menuItems = [
        { label: "Home", path: "/", hasSubmenu: false },
        { label: "Quem pode doar?", path: "/quem-pode-doar" },
    ];
    return (_jsxs(Box, Object.assign({ sx: {
            alignSelf: "stretch",
            overflow: "hidden",
            display: "inline-flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            gap: "28px",
            p: 4,
            background: "var(--hemoes-sidebar-bg)",
            height: "100%",
            minWidth: { xs: 280, md: "auto" },
        } }, { children: [_jsx("img", { src: `${process.env.PUBLIC_URL}/images/logo-black.png`, alt: "HEMOES", style: {
                    width: "120px",
                    height: "32px",
                    objectFit: "contain",
                    display: "block",
                } }), menuItems.map((item) => (_jsx(Box, Object.assign({ sx: {
                    alignSelf: "stretch",
                    paddingBottom: "8px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                } }, { children: _jsxs(Box, Object.assign({ sx: {
                        alignSelf: "stretch",
                        display: "inline-flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        gap: "8px",
                        cursor: "pointer",
                        "&:hover": {
                            "& .menu-text": {
                                color: "var(--hemoes-sidebar-hover-text)",
                            },
                            "& .menu-indicator": {
                                background: "var(--hemoes-sidebar-hover-indicator)",
                            },
                        },
                    }, onClick: () => onNavigate === null || onNavigate === void 0 ? void 0 : onNavigate(item.path), "data-testid": `sidebar-menu-item-${item.label
                        .toLowerCase()
                        .replace(/\s+/g, "-")}` }, { children: [_jsx(Box, { className: "menu-indicator", sx: {
                                width: "4px",
                                height: "20px",
                                borderRadius: "30px",
                                background: location.pathname === item.path
                                    ? "var(--hemoes-sidebar-indicator-active)"
                                    : "var(--hemoes-sidebar-indicator)",
                                transition: "background-color 0.2s",
                            } }), _jsx(Box, Object.assign({ className: "menu-text", sx: {
                                flex: "1 1 0",
                                alignSelf: "stretch",
                                color: location.pathname === item.path
                                    ? "var(--hemoes-sidebar-text-active)"
                                    : "var(--hemoes-sidebar-text)",
                                fontSize: "calc(16px + var(--accessibility-font-delta, 0px))",
                                fontWeight: 500,
                                lineHeight: "24px",
                                letterSpacing: "0.15px",
                                transition: "color 0.2s",
                            } }, { children: item.label })), item.hasSubmenu && (_jsx(Box, Object.assign({ sx: {
                                width: 24,
                                height: 24,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            } }, { children: _jsx(KeyboardArrowDownIcon, { sx: {
                                    fontSize: "calc(20px + var(--accessibility-font-delta, 0px))",
                                    color: "var(--hemoes-sidebar-text)",
                                } }) })))] })) }), item.path)))] })));
};
export const Sidebar = (props) => {
    const { isOpen, closeSidebar } = useSidebar();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    if (isMobile) {
        return (_jsx(Drawer, Object.assign({ anchor: "left", open: isOpen, onClose: closeSidebar, sx: {
                "& .MuiDrawer-paper": {
                    width: 280,
                    boxSizing: "border-box",
                },
            } }, { children: _jsx(SidebarContent, Object.assign({}, props)) })));
    }
    return (_jsx(Box, Object.assign({ sx: {
            width: 280,
            flexShrink: 0,
            display: { xs: "none", md: "block" },
        } }, { children: _jsx(SidebarContent, Object.assign({}, props)) })));
};
